export const list = ({ theme: { zIndex } }) => ({
    position: 'fixed',
    bottom: '3rem',
    left: '2.5rem',
    zIndex: zIndex.messages,
    display: 'grid',
    gridRowGap: '1rem',
    maxWidth: '35rem',
});
